import { render, staticRenderFns } from "./PaySchedulesYetToBePaid.vue?vue&type=template&id=4f389e9a&"
import script from "./PaySchedulesYetToBePaid.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaySchedulesYetToBePaid.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports